import { ApiDocumentImpl } from "../data/ApiDocumentImpl";
import { IApiDocumentRepository } from "../domain/repositories/IApiDocumentRepository";
import { ApiDocumentUseCase } from "../domain/useCases/ApiDocumentUseCase";
import { ApiDocumentViewModel } from "../presentation/viewModel/ApiDocumentViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class ApiDocumentInjection extends InjectionModule {
  private static readonly apiDocumentRepositoryToken = Symbol(
    "IApiDocumentRepository",
  );
  private static readonly apiDocumentUseCaseToken =
    Symbol("ApiDocumentUseCase");
  private static readonly apiDocumentViewModelToken = Symbol(
    "ApiDocumentViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.apiDocumentRepositoryToken,
      useClass: ApiDocumentImpl,
    },
    {
      scope: "otherRepo",
      token: this.apiDocumentUseCaseToken,
      useClass: ApiDocumentUseCase,
    },
    {
      scope: "viewModel",
      token: this.apiDocumentViewModelToken,
      useClass: ApiDocumentViewModel,
    },
  ];

  static getRepo(): IApiDocumentRepository {
    return this.resolve(this.apiDocumentRepositoryToken);
  }

  static getUseCase(): ApiDocumentUseCase {
    return this.resolve(this.apiDocumentUseCaseToken);
  }
}
